const LandingSingle = () => import("@songfinch/customer/views/templates/LandingSingle");

export default [
    {
        path: "/custom-gift/:slug",
        name: "LandingSingle",
        component: LandingSingle
    },
];
